import React from 'react'
import { StepRoot, StepGrid, ContentPanel, SidePanel } from './styles'

interface StepLayoutProps {
  sidebar?: React.ReactNode
  children: React.ReactNode
}

const StepLayout = ({ sidebar, children }: StepLayoutProps) => (
  <StepRoot>
    <StepGrid hasSidebar={!!sidebar}>
      <ContentPanel>{children}</ContentPanel>
      {sidebar && <SidePanel>{sidebar}</SidePanel>}
    </StepGrid>
  </StepRoot>
)

export default StepLayout
